
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import TrackPlayer from "../../discover/components/TrackPlayer.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "kt-menu",
  components: {
    TrackPlayer,
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const scrollElRef = ref<null | HTMLElement>(null);

    const handleClick = (value) => {
      if (!value.disabled) {
        store.dispatch("EventsModule/clearSearchQuery");
        store.dispatch("DiscoverModule/changeSelectedMenu", value.name);
      }
    };

    const selectedMenu = computed(() => {
      return store.getters["DiscoverModule/getCurrentlySelectedMenu"];
    });

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      handleClick,
      selectedMenu,
    };
  },
});
